class StandarViewDocumentsData {

    constructor() {
        this._difficultyTimesFormatted = [];
        this._difficultyPointsFormatted = [];
        this._documentTags = [];
        this._folder = null;
        this._isRootFolder = true;
    }

    getDifficultyTimesFormatted() {
        return this._difficultyTimesFormatted;
    }

    getDifficultyPointsFormatted() {
        return this._difficultyPointsFormatted;
    }

    getDocumentTags() {
        return this._documentTags;
    }

    getFolder() {
        return this._folder;
    }

    getIsRootFolder() {
        return this._isRootFolder;
    }

    getContext() {
        return {
            world: world,
            folder: this._folder,
            visual_mode: this._folder.visual_mode,
            isRootFolder: this._isRootFolder,
            filtersAmount: DocumentationUtils.getAvailableFiltersAmount(world),
            difficultySizes: ['S', 'M', 'L', 'XL'],
            difficultySizesTrans: ['TR_S', 'TR_M', 'TR_L', 'TR_XL'],
            difficultyPointsTrans: ['TR_BASICO', 'TR_MEDIO', 'TR_DIFICIL', 'TR_EXTRA'],
            difficultyTimesFormatted: this._difficultyTimesFormatted,
            difficultyPointsFormatted: this._difficultyPointsFormatted,
            searchFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_SEARCH"],
            smile1Icon: customIcons["RATE_SMILE_1"],
            smile2Icon: customIcons["RATE_SMILE_2"],
            smile3Icon: customIcons["RATE_SMILE_3"],
            smile4Icon: customIcons["RATE_SMILE_4"],
            smile5Icon: customIcons["RATE_SMILE_5"],
            smile0Icon: customIcons["RATE_SMILE_0"],
            documentationFavorite: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_FAVORITE"],
            documentationShareChat: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE_CHAT"],
            documentationShare: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"],
            documentationPlay: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_PLAY"],
            documentationComment: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_COMMENT"],
            documentationRate: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_RATE"],
            folderStack: documentationScreenController.foldersStack.length,
            canvasColor: this._folder.visual_mode && this._folder.visual_mode.canvas_color ? this._folder.visual_mode.canvas_color : 'ECECEC',
            tags: this._documentTags,
            newDocumentTypes: documentationScreenController.documentationNew.getDocumentTypes(),
            isLmsPath: storage.getItem("lms_path_id") !== null,
            filters: {
                classSelector: 'documents-filter',
                playFilterId: 'sort-play-' + this._folder.id,
                playFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_PLAY"],
                testFilterId: 'sort-test-' + this._folder.id,
                testFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_TEST"],
                completedFilterId: 'sort-completed-' + this._folder.id,
                completedFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NOT_SEEN"],
                favouriteFilterId: 'sort-favourite-' + this._folder.id,
                favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
                newFilterId: 'sort-new-' + this._folder.id,
                newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"],
                shareFiltersId: 'sort-share-' + this._folder.id,
                shareFiltersIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_SHARE_LINK"],
                ratingFilterId: 'sort-rating-' + this._folder.id,
                ratingFiltersIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_RATE"],
            },
            chatTabEnabled: $('.chatTab').length > 0,
        };
    }

    setDifficultyTimesFormatted(difficultyTimesFormatted) {
        this._difficultyTimesFormatted = difficultyTimesFormatted;
    }

    setDifficultyPointsFormatted(difficultyPointsFormatted) {
        this._difficultyPointsFormatted = difficultyPointsFormatted;
    }

    setDocumentTags(documentTags) {
        this._documentTags = documentTags;
    }

    setFolder(folder) {
        this._folder = folder;
    }

    setIsRootFolder(isRootFolder) {
        this._isRootFolder = isRootFolder;
    }

}